import * as React from "react";

const SVGComponent = () => (
  <svg
    id='Layer_1'
    data-name='Layer 1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    viewBox='0 0 2560.23 1599.04'>
    <defs>
      <style>
        {
          ".cls-1,.cls-12{fill:#1b3d9e;}.cls-2{fill:#d4dfff;}.cls-3{fill:#fc476a;}.cls-4{fill:#fe8e9c;}.cls-5{fill:#f6f9ff;}.cls-6{fill:#1c056d;}.cls-7{clip-path:url(#clip-path);}.cls-10,.cls-17,.cls-8{fill:#6880e4;}.cls-9{clip-path:url(#clip-path-2);}.cls-10{opacity:0.46;}.cls-11{fill:#fff;}.cls-12{opacity:0.54;}.cls-13{clip-path:url(#clip-path-3);}.cls-14{clip-path:url(#clip-path-4);}.cls-15{fill:#d40221;}.cls-16{clip-path:url(#clip-path-5);}.cls-17{opacity:0.17;}.cls-18{clip-path:url(#clip-path-6);}.cls-19{fill:#e57492;}.cls-20{clip-path:url(#clip-path-7);}.cls-21{clip-path:url(#clip-path-8);}.cls-22{clip-path:url(#clip-path-9);}.cls-23{clip-path:url(#clip-path-10);}.cls-24{clip-path:url(#clip-path-11);}"
        }
      </style>
      <clipPath id='clip-path' transform='translate(-207.84 -197.1)'>
        <path
          className='cls-1'
          d='M670.12,1779.34s-98.22-331.89-82.4-340.68,403.53-9.13,403.53-9.13-44.46,349.06-56.8,349.81S702.81,1780.85,670.12,1779.34Z'
        />
      </clipPath>
      <clipPath id='clip-path-2' transform='translate(-207.84 -197.1)'>
        <path
          className='cls-2'
          d='M896,711.36S891.55,1441,909.14,1443s1299.5,10,1310.5,0,15.39-737.63,0-737.63S896,711.36,896,711.36Z'
        />
      </clipPath>
      <clipPath id='clip-path-3' transform='translate(-207.84 -197.1)'>
        <rect
          className='cls-1'
          x={2163.65}
          y={1365.73}
          width={357.03}
          height={412.98}
          rx={12.08}
        />
      </clipPath>
      <clipPath id='clip-path-4' transform='translate(-207.84 -197.1)'>
        <path
          className='cls-3'
          d='M2258,1365.73s-4.74-340,1.58-343.92,54.48-7.89,58.43,1.58,0,342.34,0,342.34Z'
        />
      </clipPath>
      <clipPath id='clip-path-5' transform='translate(-207.84 -197.1)'>
        <path
          className='cls-2'
          d='M2357.1,871.32h132a3.73,3.73,0,0,1,3.73,3.73v490.67a0,0,0,0,1,0,0H2353.37a0,0,0,0,1,0,0V875.06A3.73,3.73,0,0,1,2357.1,871.32Z'
        />
      </clipPath>
      <clipPath id='clip-path-6' transform='translate(-207.84 -197.1)'>
        <path
          className='cls-4'
          d='M1172.41,613l-53,6.85c-29.17-13.66-57.41-22.51-83.75-19.76s-41.64,30.46-35.12,49.1c5.74,16.41,53.34,33.23,73.87,33.62s51.72-4.34,63.17-14.5l0-.05h34.76Z'
        />
      </clipPath>
      <clipPath id='clip-path-7' transform='translate(-207.84 -197.1)'>
        <path
          className='cls-1'
          d='M1119.44,619.89s-17,1.51-20.27,1.59c-11.89.29-23.81.94-23.81.94s-7.41-24-18.3-19.12c-16,7.24,2.29,18.47,2.29,18.47s-28.44-4.74-31.22-4.9,21.29,50.59-4.38,66-54.27,7.3-57.84-32.67,37.37-78.31,75.06-77S1119.44,619.89,1119.44,619.89Z'
        />
      </clipPath>
      <clipPath id='clip-path-8' transform='translate(-207.84 -197.1)'>
        <path
          className='cls-4'
          d='M1239.14,984.94s-7.91,10.65-10.53,15.91-3.45,31.6-2.9,31.51,6.39-.4,7.61-3.88l6.47-22.23s.44,23.84-.35,25.52-14.52,29-13.31,29.92,6.41,4,10.46-2.78,13.63-24.47,14.81-27.29-18.76,37.2-18,37.52,5.91,3,7.93.36,19.87-31,20.46-33.31-11.12,27.22-10.51,27.21,2.94,3,6.14-1,13.91-25.66,14.43-26.8.35-14.91.35-14.91,2.67,16.18,2,18.29-5.54,14.37-3.26,14.8c1.73.33,4.74-3,7.11-7.34s5.37-10.85,5.14-17-11.6-40.78-11.6-40.78Z'
        />
      </clipPath>
      <clipPath id='clip-path-9' transform='translate(-207.84 -197.1)'>
        <path
          className='cls-1'
          d='M2074.66,620s-339.36-27.85-409.84-42.64-129.2,17.36-129.2,17.36v72.14S1718,822.26,1799.77,824.3s252.82-43.61,254.18-51.11,0-51.79-6.81-54.52-233.06,23.17-237.15,18.4c-2.66-3.1-41-41.56-74.58-70.19h339.25Z'
        />
      </clipPath>
      <clipPath id='clip-path-10' transform='translate(-207.84 -197.1)'>
        <path
          className='cls-1'
          d='M2082.14,721.89s5.8-9.25,16.65-10.77,14.37,0,14.37,0,29.12,78.9,23.84,80.57-17.24,1.95-20.85-1.39-31-41.48-31-41.48S2086.89,728.19,2082.14,721.89Z'
        />
      </clipPath>
      <clipPath id='clip-path-11' transform='translate(-207.84 -197.1)'>
        <path
          className='cls-1'
          d='M2107.44,641.94a18,18,0,0,1,15.48-10.56c11.54-.63,38.53,13.73,40.93,14.75s34.92,9.76,35.48,10c7,3.52.77,11.82.77,11.82l-90.53-1.07Z'
        />
      </clipPath>
    </defs>
    <path
      className='cls-5'
      d='M1031.56,1601.61c-108.75-32.29-213.43-74.26-304.1-132.1-391.64-249.86-305.55-828.64,1.77-1109.86C825.6,271.46,950.46,209.93,1081.58,199,1228.32,186.81,1382,232.86,1492.4,331.5c100.36,89.62,159.31,212.59,289.85,265.71,151.41,61.6,319.33,37.47,478,55.72,311.95,35.87,515.8,309.2,446.9,621.09C2627.33,1635.5,2295.07,1716,1973,1728.54c-186.72,7.31-373.44-11.43-557.28-43.18C1292.8,1664.13,1159.37,1639.56,1031.56,1601.61Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-2'
      d='M669,1165.44a59.6,59.6,0,0,1-98.24-35.72c-3.8-24.7,6.72-54.39-10.75-72.28-8.77-9-22.72-12.07-30.16-22.19-6.24-8.5-6.38-19.87-6.26-30.42q.3-28.08.62-56.17c-8.34-10.4-25.15-9.77-35.09-18.63s-12-23.06-13.75-36.12A1080.47,1080.47,0,0,0,453.5,779.27c29.2,8.58,58.11,17.88,85.79,30.54,15.44,7.06,31.59,15.68,39.35,30.8S583.94,874,583.7,891c-.08,5.52.15,11.22,2.48,16.22,6,12.9,22.56,15.87,34.9,23a50.8,50.8,0,0,1,24.76,38.08c1.48,14.19-3.13,28.67-.45,42.68,6,31.07,43.17,45.41,58.05,73.32C719,1113.49,693.83,1143.62,669,1165.44Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-6'
      d='M745.6,1443.05a1.06,1.06,0,0,1-1-.88c-5.86-33.92-26.33-125.61-61.9-229.88-26.1-76.53-56.32-148.87-89.83-215-41.88-82.65-89-155.77-140.15-217.36a1.06,1.06,0,0,1,1.64-1.35c51.22,61.71,98.47,135,140.42,217.77,33.55,66.22,63.82,138.65,90,215.28,35.6,104.39,56.1,196.21,62,230.17a1.07,1.07,0,0,1-.86,1.23Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-2'
      d='M207.84,1077.86c10,8.08,14.29,21.1,19.39,32.93s12.88,24.18,25.4,27.21c13.57,3.29,27.83-5.68,41.46-2.63,11,2.46,18.86,12.17,24.69,21.86s10.91,20.34,19.91,27.18c14,10.62,33.4,9.24,50.8,6.84s36.32-5,51.49,3.79c18.46,10.75,25.34,35.24,43.67,46.23,7.79,4.67,17,6.43,26.06,7.11a123.7,123.7,0,0,0,77.13-20.28c-1.3-24.62-9.86-51.24-25.34-70.44s-38.73-32.55-63.35-33.86c-7.86-.41-15.8.35-23.57-.94-32.61-5.43-49.56-43.29-79.78-56.7a58.88,58.88,0,0,0-41.16-2.3c-13.11,4.15-24.81,12.92-38.48,14.37-13.35,1.42-26.25-4.37-39.18-8C252.18,1063.25,232.08,1069.13,207.84,1077.86Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-6'
      d='M736.46,1434.35a1.07,1.07,0,0,1-1-.8c-15.52-60.69-50.27-118.84-100.47-168.17-43.14-42.38-98.55-79.08-164.67-109.07-71.16-32.27-153.24-56.73-258.31-77a1.06,1.06,0,1,1,.4-2.08c105.24,20.29,187.48,44.81,258.78,77.15,66.36,30.09,122,66.93,165.29,109.49,50.48,49.59,85.42,108.09,101,169.15a1.05,1.05,0,0,1-.77,1.29A.75.75,0,0,1,736.46,1434.35Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-2'
      d='M778.27,1076.78a54.26,54.26,0,0,1-64.53-52.44c-.18-12,3.6-23.67,7.73-34.94,1.41-3.85,2.89-7.88,2.38-11.95-.41-3.23-2-6.17-3.82-8.9-6.67-10.26-16-19.18-19.5-30.91-6.25-20.82,7.65-43.23,3.3-64.52-1.52-7.42-5.18-14.2-7.79-21.31-9.19-25-4.38-54.72,12.25-75.57,23.41,9.39,38.68,34.34,38.91,59.56.12,12.58-3.33,25.89,2,37.27,3.2,6.81,9.12,11.86,14.66,16.93,9.71,8.9,19.08,19.09,22.51,31.8,5.4,20-4.93,42,1.76,61.58,6.65,19.42,28.28,31,34.16,50.64a44.77,44.77,0,0,1,1.46,16.34c-.69,8.43-3.46,17.13-9.81,22.72C804.06,1081.78,791.2,1074.29,778.27,1076.78Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-6'
      d='M787.07,1439.58a1.07,1.07,0,0,1-1.06-1c-4.59-53.95-3.33-109.18-2.11-162.59,1.68-73.87,3.42-150.26-10.39-223.89-7.14-38.08-18.57-76-29.61-112.61-15.37-51-31.26-103.68-35.8-157.56a1.06,1.06,0,0,1,1-1.15,1.07,1.07,0,0,1,1.15,1c4.52,53.65,20.38,106.26,35.71,157.12,11.06,36.7,22.5,74.64,29.67,112.83,13.85,73.85,12.11,150.36,10.42,224.34-1.21,53.35-2.47,108.52,2.11,162.36a1.06,1.06,0,0,1-1,1.15Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-1'
      d='M670.12,1779.34s-98.22-331.89-82.4-340.68,403.53-9.13,403.53-9.13-44.46,349.06-56.8,349.81S702.81,1780.85,670.12,1779.34Z'
      transform='translate(-207.84 -197.1)'
    />
    <g className='cls-7'>
      <path
        className='cls-6'
        d='M765.84,1403.86s-113.43,144.91-107,148.78,325.08,69.6,324.95,65.73,32.4-188.84,32.4-188.84Z'
        transform='translate(-207.84 -197.1)'
      />
    </g>
    <rect
      className='cls-1'
      x={1212.62}
      y={1297.19}
      width={277.43}
      height={235.77}
    />
    <rect
      className='cls-6'
      x={1107}
      y={1532.96}
      width={495.37}
      height={50.15}
      rx={20.85}
    />
    <path
      className='cls-8'
      d='M862.12,672.05a3.46,3.46,0,0,1,3.09-1.91c55.95-.38,1341.22-8.93,1398.16,0,22.45,3.52,16.87,858.08,0,890.73-12.4,24-1384.11,2.9-1400,0C843.68,1557.31,834,728.19,862.12,672.05Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-2'
      d='M896,711.36S891.55,1441,909.14,1443s1299.5,10,1310.5,0,15.39-737.63,0-737.63S896,711.36,896,711.36Z'
      transform='translate(-207.84 -197.1)'
    />
    <g className='cls-9'>
      <polygon
        className='cls-10'
        points='1530.03 491.73 1031.84 1265.21 663.59 1265.21 688.1 514.26 1530.03 491.73'
      />
      <polygon
        className='cls-10'
        points='1145.57 1271.52 1624.4 487.58 1834.52 487.58 1373.2 1267.42 1145.57 1271.52'
      />
      <polygon
        className='cls-10'
        points='1923.39 490.49 1459.79 1272.19 1746.97 1268.56 2055.37 700.94 2049.15 495.43 1923.39 490.49'
      />
    </g>
    <circle
      className='cls-1'
      cx={1559.18}
      cy={1516.44}
      r={33.72}
      transform='translate(-669.47 515.01) rotate(-22.5)'
    />
    <path
      className='cls-11'
      d='M1241.17,1026.61q2.47-11.56,9.71-17.57a25.45,25.45,0,0,1,15.93-6.2,27.68,27.68,0,0,1,16.54,5.16q7.85,5.38,11.16,16.55.4,26.88.42,53.14t.82,52.72q18.2,0,35.36-.41t32.88-.42q11.16,3.32,16.54,10.55a24,24,0,0,1,5.17,15.09q-.21,7.86-6.21,14.48t-17.57,9.1q-16.12,0-32.26.2t-32.25-.2q.83,20.67,1,44.86t.62,44.87q-.82,13.65-8.89,20.27a27.66,27.66,0,0,1-18,6.61q-9.92,0-18.81-6.82t-10.55-20.06q-.42-21.09.62-44.45t.21-44.46q-17.79-.4-38.25-1.86a246.81,246.81,0,0,1-39.7-6,155.75,155.75,0,0,1-35.36-12.81,72.47,72.47,0,0,1-26-21.92,55,55,0,0,1-10.34-27.71,90,90,0,0,1,2.89-30.6,158,158,0,0,1,12.41-31.84,343,343,0,0,1,18-31q9.71-14.88,19.43-27.91t17.17-23q16.53-22.34,33.91-43.42t34.73-42.6q9.09-7.44,18.82-7.65a27.33,27.33,0,0,1,16.75,4.76,25.42,25.42,0,0,1,9.71,14.06q2.68,9.09-1.44,20.26-14.07,17.37-33.09,39.49t-37.42,46.32a553.29,553.29,0,0,0-33.5,49.21q-15.09,25-21.29,48.59-2.49,8.28,1.86,14.27t12.82,9.92a95.51,95.51,0,0,0,19.64,6.41,208.43,208.43,0,0,0,22.12,3.72q11,1.25,20.27,1.86t14.26,1q-.83-26.06-.82-52.31Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-11'
      d='M1441.73,1217.25q-5.37-17.77-10.75-44.45a517.7,517.7,0,0,1-8.06-57.69,566.16,566.16,0,0,1-1.86-63.68,335.25,335.25,0,0,1,7.23-62.45,202.22,202.22,0,0,1,19.64-54.17q13.23-24.39,35.16-38.46a194.77,194.77,0,0,1,56.24-24.81,182.86,182.86,0,0,1,56.65-5.79,166,166,0,0,1,52.73,11.78,143.62,143.62,0,0,1,43.83,27.5,132.35,132.35,0,0,1,30.19,41.77q11.37,24.41,12.2,54.59.4,28.53,2.07,61t.2,65.14a348.53,348.53,0,0,1-8.47,63.06,166.71,166.71,0,0,1-23.16,54.79,103.31,103.31,0,0,1-36.6,33.5,165.42,165.42,0,0,1-49.62,18,196.51,196.51,0,0,1-54.8,2.69,178.79,178.79,0,0,1-52.72-12.62,144.46,144.46,0,0,1-43.43-27.5A95.65,95.65,0,0,1,1441.73,1217.25Zm69.06-273.34q-10.76,8.28-19.23,24.19a83.36,83.36,0,0,0-9.72,33.7q-1.65,24.81-3.3,50.25t-1.24,50.24a356,356,0,0,0,4.13,48.8,176.07,176.07,0,0,0,13.65,45.9,62.88,62.88,0,0,0,18.4,24.4,91.42,91.42,0,0,0,27.29,15.3,106.53,106.53,0,0,0,32,6,120.7,120.7,0,0,0,33.09-3.31,106.7,106.7,0,0,0,30.39-12.62,82.81,82.81,0,0,0,24.19-22.33q7-8.68,11.37-24.19a213.72,213.72,0,0,0,6.41-34.53q2.07-19,2.49-39.28t0-38.46q-.42-18.2-.83-32.46t-.42-20.89A93.7,93.7,0,0,0,1626,927a94.9,94.9,0,0,0-35.15-9.1,110,110,0,0,0-39.28,5Q1531.06,929,1510.79,943.91Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-11'
      d='M1930.12,1026.61q2.48-11.56,9.72-17.57a25.42,25.42,0,0,1,15.92-6.2,27.68,27.68,0,0,1,16.54,5.16q7.85,5.38,11.16,16.55.4,26.88.42,53.14t.82,52.72q18.19,0,35.36-.41t32.88-.42q11.16,3.32,16.54,10.55a24,24,0,0,1,5.17,15.09q-.21,7.86-6.2,14.48t-17.58,9.1q-16.12,0-32.26.2t-32.25-.2q.83,20.67,1,44.86t.62,44.87q-.83,13.65-8.89,20.27a27.66,27.66,0,0,1-18,6.61q-9.92,0-18.81-6.82t-10.55-20.06q-.42-21.09.62-44.45t.21-44.46q-17.79-.4-38.25-1.86a246.81,246.81,0,0,1-39.7-6,155.75,155.75,0,0,1-35.36-12.81,72.47,72.47,0,0,1-26-21.92,55,55,0,0,1-10.34-27.71,90,90,0,0,1,2.89-30.6,158,158,0,0,1,12.41-31.84,343,343,0,0,1,18-31q9.7-14.88,19.43-27.91t17.17-23q16.53-22.34,33.91-43.42t34.73-42.6q9.09-7.44,18.82-7.65a27.31,27.31,0,0,1,16.75,4.76,25.48,25.48,0,0,1,9.72,14.06q2.67,9.09-1.45,20.26-14.07,17.37-33.08,39.49t-37.43,46.32a553.29,553.29,0,0,0-33.5,49.21q-15.09,25-21.29,48.59-2.49,8.28,1.86,14.27t12.82,9.92a95.51,95.51,0,0,0,19.64,6.41,208.43,208.43,0,0,0,22.12,3.72q11,1.25,20.27,1.86t14.26,1q-.82-26.06-.82-52.31Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-12'
      d='M1160.5,1566.56,1027.91,1193.8l33.67,5.41a5.31,5.31,0,0,1,4.15,3.43l132.69,364.27a.13.13,0,0,1-.12.17Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-3'
      d='M734.25,1582.39c5.6-1,280.68-391.45,293.66-388.59s164.14,461.73,158.53,460.84S720.34,1584.85,734.25,1582.39Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-11'
      d='M985.14,1519.24a15.78,15.78,0,0,1-6.5,3.72,11.52,11.52,0,0,1-6.33-.06,12.69,12.69,0,0,1-5.48-3.4,15.93,15.93,0,0,1-3.72-6.51q2-24.6,3.08-50t2.74-50.48q1.65-25.08,4.79-49.41a346.78,346.78,0,0,1,9.23-46.81q.49-1.82,3.37-3.26a22.91,22.91,0,0,1,7-2.06,51,51,0,0,1,9-.48,48,48,0,0,1,9.32,1.16,28.43,28.43,0,0,1,8,3.06,12.49,12.49,0,0,1,5.08,5.25q2.61,3.57,3.12,12.32a164.07,164.07,0,0,1-.39,21.06q-.9,12.33-3.29,27.37t-5.65,30.89q-3.25,15.87-7.16,31.82t-8.28,30.17q-4.37,14.19-8.76,25.86a132.9,132.9,0,0,1-8.48,18.82A3.32,3.32,0,0,1,985.14,1519.24Zm-28.47,62.23a29.07,29.07,0,0,1-7.28-8,21.49,21.49,0,0,1-3.18-9.27,16.18,16.18,0,0,1,2-9.19,20.73,20.73,0,0,1,8-7.81q7.72-4.7,15.46-3.57t11.92,9.39a30.56,30.56,0,0,1,3.78,15.5q-.17,8.31-7.25,14.37a14.14,14.14,0,0,1-11.7,3.85A22.09,22.09,0,0,1,956.67,1581.47Z'
      transform='translate(-207.84 -197.1)'
    />
    <rect
      className='cls-1'
      x={1955.81}
      y={1168.64}
      width={357.03}
      height={412.98}
      rx={12.08}
    />
    <g className='cls-13'>
      <path
        className='cls-6'
        d='M2530.74,1424.21s-139.84,196.9-392.93,251.4v120.52h401.74S2550,1431.26,2530.74,1424.21Z'
        transform='translate(-207.84 -197.1)'
      />
    </g>
    <path
      className='cls-3'
      d='M2258,1365.73s-4.74-340,1.58-343.92,54.48-7.89,58.43,1.58,0,342.34,0,342.34Z'
      transform='translate(-207.84 -197.1)'
    />
    <g className='cls-14'>
      <polygon
        className='cls-15'
        points='2091.49 873.21 2091.49 1175.35 2068.94 1175.35 2068.94 873.82 2091.49 873.21'
      />
      <path
        className='cls-2'
        d='M2247,1083.37s70.09-5.32,79.86-.43c0,0-.49-69.86-4.4-71.33s-70.83-1.84-72.3,5.92S2247,1083.37,2247,1083.37Z'
        transform='translate(-207.84 -197.1)'
      />
    </g>
    <path
      className='cls-2'
      d='M2149.26,674.23h132A3.73,3.73,0,0,1,2285,678v490.67a0,0,0,0,1,0,0H2145.52a0,0,0,0,1,0,0V678A3.73,3.73,0,0,1,2149.26,674.23Z'
    />
    <g className='cls-16'>
      <rect
        className='cls-10'
        x={2134.33}
        y={656.16}
        width={47.85}
        height={530.48}
      />
      <rect
        className='cls-8'
        x={2145.52}
        y={712.16}
        width={17.57}
        height={6.12}
      />
      <rect
        className='cls-8'
        x={2145.52}
        y={740.34}
        width={17.57}
        height={6.12}
      />
      <rect
        className='cls-8'
        x={2145.52}
        y={768.52}
        width={17.57}
        height={6.12}
      />
      <rect
        className='cls-8'
        x={2145.52}
        y={796.71}
        width={17.57}
        height={6.12}
      />
      <rect
        className='cls-8'
        x={2145.52}
        y={824.89}
        width={17.57}
        height={6.12}
      />
      <rect
        className='cls-8'
        x={2145.52}
        y={853.08}
        width={17.57}
        height={6.12}
      />
      <rect
        className='cls-8'
        x={2145.52}
        y={881.26}
        width={17.57}
        height={6.12}
      />
      <rect
        className='cls-8'
        x={2145.52}
        y={909.44}
        width={17.57}
        height={6.12}
      />
      <rect
        className='cls-8'
        x={2145.52}
        y={937.63}
        width={17.57}
        height={6.12}
      />
      <rect
        className='cls-8'
        x={2145.52}
        y={965.81}
        width={17.57}
        height={6.12}
      />
      <rect
        className='cls-8'
        x={2145.52}
        y={993.99}
        width={17.57}
        height={6.12}
      />
      <rect
        className='cls-8'
        x={2145.52}
        y={1022.18}
        width={17.57}
        height={6.12}
      />
      <rect
        className='cls-8'
        x={2145.52}
        y={1050.36}
        width={17.57}
        height={6.12}
      />
      <rect
        className='cls-8'
        x={2145.52}
        y={1078.55}
        width={17.57}
        height={6.12}
      />
      <rect
        className='cls-8'
        x={2145.52}
        y={1106.73}
        width={17.57}
        height={6.12}
      />
      <rect
        className='cls-8'
        x={2145.52}
        y={1134.91}
        width={17.57}
        height={6.12}
      />
      <path
        className='cls-17'
        d='M2462.68,852.67c-38.71,33.16-52.28,92.46-31.85,139.15,9.72,22.22,26.34,42,29.45,66.09,3,23.34-7.24,46-15.35,68.12-8,21.76-14.16,44.76-12.53,67.89,2.65,37.83,25.86,73.21,22.07,110.94-3.64,36.24-31.83,67.8-30.21,104.18.47,0-.49,1.6,0,1.6h90.62l0-560.29,11.14.11Z'
        transform='translate(-207.84 -197.1)'
      />
    </g>
    <path
      className='cls-6'
      d='M2763.83,1784.46H474.32a4.25,4.25,0,0,1,0-8.5H2763.83a4.25,4.25,0,0,1,0,8.5Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-4'
      d='M1172.41,613l-53,6.85c-29.17-13.66-57.41-22.51-83.75-19.76s-41.64,30.46-35.12,49.1c5.74,16.41,53.34,33.23,73.87,33.62s51.72-4.34,63.17-14.5l0-.05h34.76Z'
      transform='translate(-207.84 -197.1)'
    />
    <g className='cls-18'>
      <path
        className='cls-19'
        d='M1056,685.37s10.2-19.92,9.73-35.21S1044.25,611,1044.25,611l-17.44.89s5.69,55.84.64,65.68h0Z'
        transform='translate(-207.84 -197.1)'
      />
    </g>
    <path
      className='cls-19'
      d='M1137.61,668.35s10.49-16.11-13.9-32.37c0,0,21.75,3.52,29.22,18s5.94,14.72,5.94,14.72Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-1'
      d='M1119.44,619.89s-17,1.51-20.27,1.59c-11.89.29-23.81.94-23.81.94s-7.41-24-18.3-19.12c-16,7.24,2.29,18.47,2.29,18.47s-28.44-4.74-31.22-4.9,21.29,50.59-4.38,66-54.27,7.3-57.84-32.67,37.37-78.31,75.06-77S1119.44,619.89,1119.44,619.89Z'
      transform='translate(-207.84 -197.1)'
    />
    <g className='cls-20'>
      <path
        className='cls-6'
        d='M1001.93,690.18s19.54-16.37,18.57-34.47-6.8-46.42-3.93-48.3,33,10.14,33,10.14-5.55-8.13,4.11-12.29h0s15.3,16.75,14.22,18.5-36.23-1.75-36.23-1.75,13.79,33.86,3.92,53.87-33.63,14.3-33.63,14.3'
        transform='translate(-207.84 -197.1)'
      />
    </g>
    <path
      className='cls-5'
      d='M1118.32,668.72s-8.09-2.32-8.09-16.37V651S1118.45,665.89,1118.32,668.72Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-19'
      d='M1052.55,651.59s32.26,17.55,35.29,15.68-2.44-21.54-2.44-21.54,3.49-.24,4.3,2.91,5.36,21.66,0,22S1057.79,657.92,1052.55,651.59Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-4'
      d='M1239.14,984.94s-7.91,10.65-10.53,15.91-3.45,31.6-2.9,31.51,6.39-.4,7.61-3.88l6.47-22.23s.44,23.84-.35,25.52-14.52,29-13.31,29.92,6.41,4,10.46-2.78,13.63-24.47,14.81-27.29-18.76,37.2-18,37.52,5.91,3,7.93.36,19.87-31,20.46-33.31-11.12,27.22-10.51,27.21,2.94,3,6.14-1,13.91-25.66,14.43-26.8.35-14.91.35-14.91,2.67,16.18,2,18.29-5.54,14.37-3.26,14.8c1.73.33,4.74-3,7.11-7.34s5.37-10.85,5.14-17-11.6-40.78-11.6-40.78Z'
      transform='translate(-207.84 -197.1)'
    />
    <g className='cls-21'>
      <path
        className='cls-19'
        d='M1222.65,1010.09c.5,1.8,24.75-11.65,57.79-6.49,0,0-4.44-20.06-8-21.86s-32-1.81-36.28.24S1220.37,1001.8,1222.65,1010.09Z'
        transform='translate(-207.84 -197.1)'
      />
    </g>
    <path
      className='cls-3'
      d='M1535.62,590.09a4.38,4.38,0,0,0-3.6-4.31l-171.9-30.91c-144.19-12.34-187.71,51.49-187.71,51.49v62l16.87-.07c12.49,36.47,48,141,51.64,160,4.4,23.08-24,162.06-21,163.91s66.62,9.67,72.5,8.7,35.27-154,33.31-172.54c-1.5-14.2-5.9-111.6-16.72-160.53l226.64-.9Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-15'
      d='M1309,667.78s-4.29-22.72-23.36-38.5c0,0,101.9,20.38,131.48,22.35s118.52-5.85,118.52-5.85v21.1Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-19'
      d='M2046.74,729s35.83-8.51,36.72-6.86,6,18.06,4,24-37.17,18.81-37.17,18.81Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-1'
      d='M2074.66,620s-339.36-27.85-409.84-42.64-129.2,17.36-129.2,17.36v72.14S1718,822.26,1799.77,824.3s252.82-43.61,254.18-51.11,0-51.79-6.81-54.52-233.06,23.17-237.15,18.4c-2.66-3.1-41-41.56-74.58-70.19h339.25Z'
      transform='translate(-207.84 -197.1)'
    />
    <g className='cls-22'>
      <path
        className='cls-6'
        d='M1816.44,783.36a28.64,28.64,0,0,1-2.93-.13l-.58-.08a1.59,1.59,0,0,1,.55-3.14l.39,0a35,35,0,0,0,4.59.07,1.6,1.6,0,1,1,.1,3.19C1817.79,783.34,1817.08,783.36,1816.44,783.36Zm7.4-.33a1.59,1.59,0,0,1-.11-3.18c1.62-.11,3.39-.26,5.29-.43a1.6,1.6,0,0,1,.28,3.18c-1.92.17-3.71.31-5.35.43Zm10.63-.93a1.59,1.59,0,0,1-.16-3.18l5.29-.56a1.59,1.59,0,0,1,.35,3.17l-5.32.56Zm-26.31-.6a1.5,1.5,0,0,1-.62-.13c-1.44-.61-3.1-1.38-4.93-2.3a1.59,1.59,0,1,1,1.43-2.85c1.77.89,3.36,1.63,4.74,2.22a1.59,1.59,0,0,1-.62,3.06Zm36.91-.55a1.6,1.6,0,0,1-.19-3.18l5.29-.62a1.59,1.59,0,0,1,.38,3.16l-5.3.63Zm10.57-1.27a1.6,1.6,0,0,1-.19-3.18l5.28-.66a1.59,1.59,0,0,1,.4,3.16l-5.29.67Zm10.57-1.34a1.6,1.6,0,0,1-.21-3.18l5.28-.69a1.59,1.59,0,0,1,.42,3.16l-5.29.69Zm10.55-1.4a1.59,1.59,0,0,1-.21-3.17l5.27-.72a1.59,1.59,0,1,1,.43,3.16l-5.27.72Zm-78.17-.18a1.64,1.64,0,0,1-.76-.19q-2.22-1.22-4.68-2.61a1.59,1.59,0,1,1,1.58-2.77c1.61.92,3.16,1.78,4.63,2.58a1.59,1.59,0,0,1-.77,3Zm88.72-1.26a1.59,1.59,0,0,1-.22-3.17l5.27-.73a1.6,1.6,0,0,1,.44,3.16l-5.27.73Zm10.54-1.47a1.59,1.59,0,0,1-.22-3.17l5.27-.75a1.6,1.6,0,0,1,.45,3.16l-5.27.75Zm10.54-1.5a1.59,1.59,0,0,1-.22-3.17l5.26-.76a1.6,1.6,0,0,1,.46,3.16l-5.27.76Zm-119.07-1a1.56,1.56,0,0,1-.8-.22q-2.24-1.32-4.59-2.74a1.59,1.59,0,1,1,1.64-2.73l4.56,2.72a1.59,1.59,0,0,1-.81,3Zm129.6-.49a1.59,1.59,0,0,1-.23-3.17l5.27-.77a1.59,1.59,0,0,1,1.81,1.35,1.61,1.61,0,0,1-1.35,1.81l-5.27.76Zm10.53-1.54a1.59,1.59,0,0,1-.23-3.17l5.27-.78a1.59,1.59,0,1,1,.46,3.15l-5.27.78Zm10.55-1.56a1.6,1.6,0,0,1-.23-3.18L1945,764a1.59,1.59,0,1,1,.48,3.15l-5.27.79Zm10.52-1.58a1.59,1.59,0,0,1-.23-3.17l5.26-.79a1.59,1.59,0,0,1,.48,3.15l-5.27.79ZM1780.2,766a1.6,1.6,0,0,1-.84-.24l-4.53-2.81a1.6,1.6,0,0,1,1.69-2.71c1.54,1,3,1.9,4.52,2.8a1.6,1.6,0,0,1-.84,3Zm180.85-1.26a1.59,1.59,0,0,1-.24-3.17l5.26-.8a1.59,1.59,0,1,1,.48,3.15l-5.26.8Zm10.52-1.6a1.6,1.6,0,0,1-1.57-1.36,1.58,1.58,0,0,1,1.33-1.81l5.26-.81a1.59,1.59,0,1,1,.48,3.15l-5.26.81Zm10.52-1.62a1.59,1.59,0,0,1-.24-3.17l5.26-.81a1.59,1.59,0,1,1,.49,3.15l-5.27.81A1,1,0,0,1,1982.09,761.52Zm-210.93-1.17a1.66,1.66,0,0,1-.85-.24l-4.49-2.87a1.59,1.59,0,1,1,1.71-2.68l4.49,2.85a1.59,1.59,0,0,1-.86,2.94Zm221.45-.45a1.59,1.59,0,0,1-.24-3.17l5.26-.82a1.59,1.59,0,0,1,.49,3.15l-5.26.82Zm10.52-1.64a1.59,1.59,0,0,1-.24-3.17l5.26-.82a1.59,1.59,0,0,1,.49,3.15l-5.26.82Zm10.52-1.65a1.59,1.59,0,0,1-.24-3.17l5.26-.82a1.59,1.59,0,0,1,1.82,1.32,1.61,1.61,0,0,1-1.33,1.83l-5.26.82A1.06,1.06,0,0,1,2013.65,756.61Zm10.52-1.65a1.6,1.6,0,0,1-.25-3.17l5.27-.83a1.59,1.59,0,1,1,.49,3.14l-5.26.84Zm-262-.34a1.63,1.63,0,0,1-.87-.26l-4.47-2.9a1.59,1.59,0,0,1,1.74-2.67l4.46,2.89a1.6,1.6,0,0,1-.86,2.94Zm272.5-1.33a1.59,1.59,0,0,1-.25-3.17l5.26-.84a1.59,1.59,0,1,1,.5,3.15l-5.26.84Zm10.53-1.68a1.6,1.6,0,0,1-.25-3.17l5.27-.84a1.59,1.59,0,1,1,.5,3.15l-5.27.84Zm10.55-1.69a1.6,1.6,0,0,1-.25-3.17l5.32-.86a1.6,1.6,0,0,1,.51,3.15l-5.32.86Zm-302.5-1.11a1.59,1.59,0,0,1-.88-.27l-4.45-2.93a1.59,1.59,0,0,1,1.76-2.66l4.44,2.93a1.6,1.6,0,0,1,.46,2.21A1.62,1.62,0,0,1,1753.28,748.81Zm-8.89-5.87a1.59,1.59,0,0,1-.88-.27l-4.43-2.95a1.59,1.59,0,1,1,1.77-2.65l4.43,2.95a1.59,1.59,0,0,1-.89,2.92Zm-8.85-5.91a1.65,1.65,0,0,1-.89-.27l-4.41-3a1.59,1.59,0,1,1,1.78-2.64l4.41,3a1.59,1.59,0,0,1-.89,2.92Zm-8.82-5.95a1.54,1.54,0,0,1-.89-.28l-4.41-3a1.59,1.59,0,0,1,1.79-2.64l4.4,3a1.6,1.6,0,0,1-.89,2.92Zm-8.81-6a1.54,1.54,0,0,1-.89-.28l-4.39-3a1.6,1.6,0,1,1,1.8-2.64l4.38,3a1.58,1.58,0,0,1,.42,2.21A1.61,1.61,0,0,1,1717.91,725.1Zm-8.77-6a1.57,1.57,0,0,1-.9-.28l-4.4-3a1.59,1.59,0,1,1,1.81-2.62l4.39,3a1.6,1.6,0,0,1-.9,2.91Zm-8.78-6a1.63,1.63,0,0,1-.91-.29l-4.38-3a1.6,1.6,0,1,1,1.82-2.62l4.37,3a1.59,1.59,0,0,1,.41,2.22A1.62,1.62,0,0,1,1700.36,713.06ZM1691.6,707a1.57,1.57,0,0,1-.9-.28l-4.38-3a1.59,1.59,0,1,1,1.82-2.61l4.37,3a1.59,1.59,0,0,1,.41,2.22A1.61,1.61,0,0,1,1691.6,707Zm-8.74-6.07a1.62,1.62,0,0,1-.91-.28l-4.37-3a1.59,1.59,0,1,1,1.83-2.61l4.36,3a1.59,1.59,0,0,1-.91,2.9Zm-8.73-6.09a1.62,1.62,0,0,1-.91-.28l-4.33-3a1.62,1.62,0,0,1-.41-2.23,1.58,1.58,0,0,1,2.21-.41l4.36,3.05a1.59,1.59,0,0,1,.39,2.22A1.57,1.57,0,0,1,1674.13,694.84Zm-8.72-6.1a1.56,1.56,0,0,1-.91-.29l-4.36-3.06a1.59,1.59,0,1,1,1.83-2.61l4.36,3.06a1.59,1.59,0,0,1-.92,2.9Zm-8.71-6.12a1.52,1.52,0,0,1-.91-.29l-4.36-3.06a1.6,1.6,0,0,1,1.84-2.61l4.35,3.06a1.59,1.59,0,0,1-.92,2.9Zm-8.7-6.13a1.57,1.57,0,0,1-.92-.29l-4.35-3.07a1.59,1.59,0,1,1,1.84-2.6l4.35,3.07a1.59,1.59,0,0,1-.92,2.89Zm-8.7-6.14a1.57,1.57,0,0,1-.92-.29L1634,667a1.6,1.6,0,0,1,1.84-2.61l4.35,3.08a1.59,1.59,0,0,1-.92,2.89Zm-8.7-6.14a1.58,1.58,0,0,1-.92-.3l-4.35-3.07a1.6,1.6,0,0,1,1.84-2.61l4.35,3.08a1.6,1.6,0,0,1-.92,2.9Zm-8.7-6.16a1.64,1.64,0,0,1-.92-.29l-4.35-3.08a1.6,1.6,0,0,1,1.84-2.61l4.35,3.08a1.6,1.6,0,0,1-.92,2.9Zm-8.7-6.16a1.57,1.57,0,0,1-.92-.29l-4.36-3.08a1.59,1.59,0,1,1,1.83-2.6l4.37,3.08a1.59,1.59,0,0,1-.92,2.89Zm-8.74-6.15a1.58,1.58,0,0,1-.91-.28c-2-1.4-3.49-2.42-4.39-3a1.59,1.59,0,1,1,1.76-2.66c.92.61,2.43,1.65,4.45,3.06a1.59,1.59,0,0,1-.91,2.9Z'
        transform='translate(-207.84 -197.1)'
      />
      <path
        className='cls-6'
        d='M1547.61,585.27s3,95.23,1.49,96.72-18.29-10.83-18.29-10.83-2-75.94-.38-80.66S1547.61,585.27,1547.61,585.27Z'
        transform='translate(-207.84 -197.1)'
      />
      <path
        className='cls-6'
        d='M1735.41,666.88s-73-60.06-84.2-63c0,0,73.68,16.65,130.7,32.88s298.44,12.91,298.44,12.91v24.14l-344.94-7'
        transform='translate(-207.84 -197.1)'
      />
    </g>
    <path
      className='cls-1'
      d='M2082.14,721.89s5.8-9.25,16.65-10.77,14.37,0,14.37,0,29.12,78.9,23.84,80.57-17.24,1.95-20.85-1.39-31-41.48-31-41.48S2086.89,728.19,2082.14,721.89Z'
      transform='translate(-207.84 -197.1)'
    />
    <g className='cls-23'>
      <path
        className='cls-6'
        d='M2090.32,759.32s7.74-8.81,11.47-8.62a4,4,0,0,1,3.71,2.9,2.18,2.18,0,0,1-.43,2.16c-2.17,2.48-8.47,9.53-9.85,9.18C2093.56,764.52,2090.32,759.32,2090.32,759.32Z'
        transform='translate(-207.84 -197.1)'
      />
      <path
        className='cls-6'
        d='M2098.11,770.75s7.74-8.81,11.46-8.62a4,4,0,0,1,3.72,2.9,2.18,2.18,0,0,1-.43,2.16c-2.17,2.48-8.48,9.53-9.85,9.18C2101.34,776,2098.11,770.75,2098.11,770.75Z'
        transform='translate(-207.84 -197.1)'
      />
      <path
        className='cls-6'
        d='M2105.27,709.18s27.31,81.76,27.12,85.18c0,0,9.11-.57,9.11-2.85s-22.39-82-25.23-82.33A102.21,102.21,0,0,0,2105.27,709.18Z'
        transform='translate(-207.84 -197.1)'
      />
    </g>
    <path
      className='cls-19'
      d='M2074.66,636.27s33.53,4.66,34.16,6.34.75,24.31.75,24.31l-34.91.07Z'
      transform='translate(-207.84 -197.1)'
    />
    <path
      className='cls-1'
      d='M2107.44,641.94a18,18,0,0,1,15.48-10.56c11.54-.63,38.53,13.73,40.93,14.75s34.92,9.76,35.48,10c7,3.52.77,11.82.77,11.82l-90.53-1.07Z'
      transform='translate(-207.84 -197.1)'
    />
    <g className='cls-24'>
      <path
        className='cls-6'
        d='M2116.68,631.36c1.11,1,40,19.52,45.81,20.27S2203.88,662,2203.88,662s1.92-4.87-1.24-6.7-37.56-10-40.3-11.56-35.92-14.91-38.66-14.46A46.43,46.43,0,0,0,2116.68,631.36Z'
        transform='translate(-207.84 -197.1)'
      />
      <path
        className='cls-6'
        d='M2126.51,668.76c.72-2.57,3.26-15,5.2-15.4s6.64.86,6.49,1.57-1.14,14.26-4.27,14.26S2126.51,668.76,2126.51,668.76Z'
        transform='translate(-207.84 -197.1)'
      />
      <path
        className='cls-6'
        d='M2145,672.32c.71-2.56,3.25-15,5.19-15.39s6.64.85,6.5,1.57-1.14,14.25-4.28,14.25S2145,672.32,2145,672.32Z'
        transform='translate(-207.84 -197.1)'
      />
    </g>
  </svg>
);

export default SVGComponent;
